/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-down-thin': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<path pid="0" d="M8 11l6 6 6-6" _stroke="#151522" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/arrow-down-thin.js